module.exports = __webpack_public_path__ + "static/media/included_appletv+banner.985fe0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/included_appletv+banner.jpg
// module id = 641
// module chunks = 0